import React from 'react';
import { MDBRow } from 'mdb-react-ui-kit';
import styles from './kredGuruSection.module.css';

function KredGuruSection(props) {
    return (
        <>
            <MDBRow className='d-flex align-items-center'>
                <div className='speech-bubble pt-3 pl-3 pr-3 pb-1 w-75'>
                    <p>
                        It's time to update your Splendi password. Please follow
                        these steps to reset your password:
                    </p>

                    <ul
                        className={`mt-4 ${styles.listStyle} d-flex flex-column gap-2`}
                    >
                        <li>
                            An OTP has been sent via SMS to your registered
                            cellphone number.
                        </li>
                        <li>
                            Click the continue button to enter the the OTP you
                            have received in the previous step.
                        </li>
                        <li>
                            After OTP is validated you will be taken to the
                            password reset page.
                        </li>
                        <li>
                            Follow the instructions to create a new password.
                        </li>
                    </ul>
                </div>
                <div className='w-25 text-center'>
                    <img
                        src={`/assets/img/kred_guru_+2.svg`}
                        className='img-fluid kredGuruImg'
                        alt='kred guru'
                        width={104}
                    />
                </div>
            </MDBRow>
            <MDBRow className='d-flex justify-content-center'>
                <button
                    className={styles.resetButton}
                    onClick={() => {
                        props.toggleModal();
                    }}
                >
                    Continue
                </button>
            </MDBRow>
        </>
    );
}

export default KredGuruSection;
